/**
 * ImpersonateModal - Modal for user impersonation
 */
export default function ImpersonateModal({
  show,
  onClose,
  user,
  impersonateReason,
  setImpersonateReason,
  onImpersonate,
  loading,
}) {
  if (!show || !user) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-card border border-indigo-500/30 rounded-xl max-w-md w-full p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-indigo-500/10 border border-indigo-500/20 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-bold text-foreground">Impersonate User</h3>
            <p className="text-muted-foreground text-sm">{user.email}</p>
          </div>
        </div>
        
        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
          <p className="text-indigo-800 text-sm">
            <strong>What is impersonation?</strong>
          </p>
          <p className="text-indigo-700 text-sm mt-1">
            You&apos;ll be logged in as this user and see the app exactly as they do. 
            This is useful for debugging issues or providing support.
          </p>
        </div>
        
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <p className="text-amber-800 text-sm font-medium flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            All actions during impersonation are logged
          </p>
          <p className="text-amber-700 text-xs mt-1">
            The session will automatically expire after 1 hour.
          </p>
        </div>

        <div>
          <label className="block text-sm text-muted-foreground mb-2">
            Reason for impersonation <span className="text-red-400">*</span>
          </label>
          <textarea
            placeholder="e.g., Investigating upload issue reported in support ticket #1234"
            value={impersonateReason}
            onChange={(e) => setImpersonateReason(e.target.value)}
            rows={3}
            className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-indigo-500"
            data-testid="impersonate-reason-input"
          />
        </div>

        <div className="flex gap-3">
          <button
            onClick={onImpersonate}
            disabled={loading || !impersonateReason.trim()}
            className="flex-1 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white rounded-lg transition font-medium"
            data-testid="confirm-impersonate-btn"
          >
            {loading ? "Starting..." : "Start Impersonation"}
          </button>
          <button
            onClick={() => {
              onClose();
              setImpersonateReason("");
            }}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-muted hover:bg-muted/80 disabled:opacity-50 text-foreground rounded-lg transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
